import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import { ADIUserRoleState } from "../Data/ADIUserRoleState";

const initialState: ADIUserRoleState = {
    fullAccess: false,
    accounting: false,
    employee: false,
    limitedAccess: false,
    productInfoOnly: false,
    adiProRewards: false,
    adiAdmin: false,
    administrator: false,
    mobileAdmin: false,
    nationalInventory: false,
    productInventoryOnly: false,
    punchOut: false,
    'XTEN-AV-Access': false,
};

const roleMappings: Record<string, keyof ADIUserRoleState> = {
    FullAccess: "fullAccess",
    Accounting: "accounting",
    Employee: "employee",
    LimitedAccess: "limitedAccess",
    ProductInfoOnly: "productInfoOnly",
    ADIProRewards: "adiProRewards",
    ADIAdmin: "adiAdmin",
    Administrator: "administrator",
    MobileAdmin: "mobileAdmin",
    NationalInventory: "nationalInventory",
    ProductInventoryOnly: "productInventoryOnly",
    PunchOut: "punchOut",
    'XTEN-AV-Access': "XTEN-AV-Access",
};

const reducer = {
    "HomePage/setADIUserRole": (draft: Draft<ADIUserRoleState>, action: { currentRole: string }) => {
        for (const role in roleMappings) {
            if (action.currentRole.includes(role)) {
                draft[roleMappings[role]] = true;
            }
        }
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
